export default __webpack_public_path__ + "static/media/wind.5ecfc6e1.png";